// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import "./pageRows.css"; */
.image-with-caption {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	margin: 1rem;
}
.image-with-caption.caption {
	width: 80%;
}
.image-with-caption img {
	width: 80%;
	/* max-width: 300px; */
}
.image-with-caption.rotate img {
	width: 80%;
	max-width: 300px;
	animation: rotate-layover 120s infinite linear;
}
.image-with-caption.wide {
	flex-basis: content;
}

.image-with-caption.wide img {
	width: 100%;
	max-width: unset;
}
.image-with-caption.wrap.caption {
	width: 100%;
}
.image-with-caption.wide.caption {
	width: 100%;
}
.image-with-caption.wrap.large {
	width: 100%;
}

.image-with-caption.caption p {
	font-size: 1.2rem;
	text-align: justify;
}
@media (min-width: 500px) {
	.image-with-caption.wrap.large img {
		width: 100%;
		max-width: unset;
	}
	.image-with-caption.rotate img {
		width: 65%;
		animation: rotate-layover 120s infinite linear;
	}
	.image-with-caption.wide img {
		width: 80%;
	}
	.image-with-caption.wide.caption {
		width: 80%;
	}
	.image.caption p {
		font-size: 1.4vw;
		text-align: justify;
	}
	.image-with-caption {
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		margin: unset;
	}
	.image-with-caption.caption {
		width: 65%;
	}
	.image-with-caption img {
		width: 65%;
		/* max-width: 300px; */
	}
	.image.image-with-caption img {
		width: 100%;
	}
	.image-with-caption.caption p {
		font-size: 1.45vw;
	}
}
@media (min-width: 1000px) {
	.image.caption p {
		font-size: 1.4rem;
		text-align: justify;
	}
	.image-with-caption img {
		width: 100%;
	}
	.image-with-caption.wide.caption p {
		font-size: 1.4rem;
		width: auto;
	}
	.image-with-caption.wrap.caption p {
		font-size: 1.4rem;
		line-height: unset;

		/* width: 80%; */
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/GenericPage/PageRows/ImageWithCaptions/imageWithCaptions.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;CACC,aAAa;CACb,sBAAsB;CACtB,6BAA6B;CAC7B,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;CACV,sBAAsB;AACvB;AACA;CACC,UAAU;CACV,gBAAgB;CAChB,8CAA8C;AAC/C;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC;EACC,WAAW;EACX,gBAAgB;CACjB;CACA;EACC,UAAU;EACV,8CAA8C;CAC/C;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,gBAAgB;EAChB,mBAAmB;CACpB;CACA;EACC,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;CACd;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;EACV,sBAAsB;CACvB;CACA;EACC,WAAW;CACZ;CACA;EACC,iBAAiB;CAClB;AACD;AACA;CACC;EACC,iBAAiB;EACjB,mBAAmB;CACpB;CACA;EACC,WAAW;CACZ;CACA;EACC,iBAAiB;EACjB,WAAW;CACZ;CACA;EACC,iBAAiB;EACjB,kBAAkB;;EAElB,gBAAgB;CACjB;AACD","sourcesContent":["/* @import \"./pageRows.css\"; */\n.image-with-caption {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-around;\n\talign-items: center;\n\tmargin: 1rem;\n}\n.image-with-caption.caption {\n\twidth: 80%;\n}\n.image-with-caption img {\n\twidth: 80%;\n\t/* max-width: 300px; */\n}\n.image-with-caption.rotate img {\n\twidth: 80%;\n\tmax-width: 300px;\n\tanimation: rotate-layover 120s infinite linear;\n}\n.image-with-caption.wide {\n\tflex-basis: content;\n}\n\n.image-with-caption.wide img {\n\twidth: 100%;\n\tmax-width: unset;\n}\n.image-with-caption.wrap.caption {\n\twidth: 100%;\n}\n.image-with-caption.wide.caption {\n\twidth: 100%;\n}\n.image-with-caption.wrap.large {\n\twidth: 100%;\n}\n\n.image-with-caption.caption p {\n\tfont-size: 1.2rem;\n\ttext-align: justify;\n}\n@media (min-width: 500px) {\n\t.image-with-caption.wrap.large img {\n\t\twidth: 100%;\n\t\tmax-width: unset;\n\t}\n\t.image-with-caption.rotate img {\n\t\twidth: 65%;\n\t\tanimation: rotate-layover 120s infinite linear;\n\t}\n\t.image-with-caption.wide img {\n\t\twidth: 80%;\n\t}\n\t.image-with-caption.wide.caption {\n\t\twidth: 80%;\n\t}\n\t.image.caption p {\n\t\tfont-size: 1.4vw;\n\t\ttext-align: justify;\n\t}\n\t.image-with-caption {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-around;\n\t\talign-items: center;\n\t\tmargin: unset;\n\t}\n\t.image-with-caption.caption {\n\t\twidth: 65%;\n\t}\n\t.image-with-caption img {\n\t\twidth: 65%;\n\t\t/* max-width: 300px; */\n\t}\n\t.image.image-with-caption img {\n\t\twidth: 100%;\n\t}\n\t.image-with-caption.caption p {\n\t\tfont-size: 1.45vw;\n\t}\n}\n@media (min-width: 1000px) {\n\t.image.caption p {\n\t\tfont-size: 1.4rem;\n\t\ttext-align: justify;\n\t}\n\t.image-with-caption img {\n\t\twidth: 100%;\n\t}\n\t.image-with-caption.wide.caption p {\n\t\tfont-size: 1.4rem;\n\t\twidth: auto;\n\t}\n\t.image-with-caption.wrap.caption p {\n\t\tfont-size: 1.4rem;\n\t\tline-height: unset;\n\n\t\t/* width: 80%; */\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
